import React from 'react';
import {FaPrint} from 'react-icons/fa';
import {RCard} from '@putil-view/item.r-card';
import Container from 'react-bootstrap/Container'
import Jumbotron from 'react-bootstrap/Jumbotron';
import {RIconText} from '@putil-view/item.r-icon-text';
import {QrTypeIcon} from './QrTypeIcon';
import PropTypes from 'prop-types';
import ListGroup from 'react-bootstrap/ListGroup';

 const PrintInfo = ({title, content}) =>{
	const Item =({className,children}) =>{
		return(
			<ListGroup.Item className={className}>
				<h6>
					<b>{children}</b>
				</h6>
			</ListGroup.Item>
		)
	}
	PrintInfo.propTypes = {
		className: PropTypes.string,
		children:PropTypes.node,
	};
	return(
		<ListGroup horizontal className= "border-0">
			<Item className="w-100 border-0 align-self-center">
				{title}
			</Item>
			<Item className="w-100 border-0 text-center">
				{content}
			</Item>
		</ListGroup>
	)
}
PrintInfo.propTypes = {
	title: PropTypes.node,
	content:PropTypes.node,
};


export const QrPrintResult = ({lockerId,type,printArea,dt}) =>{
  return (<RCard className="ml-6 mr-6 mt-6 pt-4 align-self-start w-100"
    title = {
      <RIconText variant="lg">
        <FaPrint/>
        <span>Print QR Code</span>
      </RIconText>
    }>
      <Jumbotron fluid className="bg-white">
        <div className="container">
          <h4 className="text-center ">New Print job is created for <a href = {"manage?id="+lockerId +"&type="+type}><QrTypeIcon type={type}/>{lockerId}</a></h4>
          <small className="text-center d-block">If label is not printed sucessfully. Please make sure TSC TE300 is selected as default printer in your computer{"'"}s control panel.</small>
					<small className="text-center d-block">If label is not printed automatically. Please add <span className="text-primary"> --kiosk-printing{'"'}</span> in the target field in chrome shortcut properties (content click it in desktop and select property). Then close all opened chrome browser and restart again.</small>
          <br/>
          {printArea &&
            <PrintInfo
              title = {<>Label</>}
              content = {<Container className="text-center">

              <>{printArea}</>
              </Container>}
              />
            }
            <PrintInfo
              title={<>Locker ID</>}
              content ={lockerId}
            />
            <PrintInfo
              title={<>Type</>}
              content ={<><QrTypeIcon  type={type}/><span>Locker</span></>
              }
            />
            <PrintInfo
              title={<>Create Time</>}
              content =	{new Date(dt).toLocaleString().replace('下午','PM\n').replace('上午','AM\n').replace(',','')}
            />
        </div>
      </Jumbotron>
  </RCard>
  )
}
QrPrintResult.propTypes = {
	lockerId:PropTypes.string,
	type:PropTypes.string,
	printArea: PropTypes.node,
  dt:PropTypes.number,
};
